import { useEffect } from 'react';

import { Redirect } from 'expo-router';

import { CardModal } from 'components/card-modal';
import { useAfterInteractions } from 'hooks/use-after-interactions';
import { LoyaltyHistory } from 'pages/loyalty/loyalty-history-modal';
import { HistorySkeleton } from 'pages/loyalty/loyalty-history-modal/components/history-skeleton';
import { t } from 'state/intl/translations';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLoyaltyContext } from 'state/loyalty';
import { routes } from 'utils/routing';

export default function LoyaltyHistoryModal() {
  const { refetchLoyaltyUser } = useLoyaltyContext();
  const enableLoyaltyProfile = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_PROFILE);
  const showContent = useAfterInteractions();

  useEffect(() => {
    refetchLoyaltyUser();
  }, [refetchLoyaltyUser]);

  if (!enableLoyaltyProfile) {
    // Redirects to the History tab
    return <Redirect href={routes.rewardsHistory} />;
  }

  return (
    <CardModal alwaysShowHeader headerText={t('historyTitle')}>
      {showContent ? <LoyaltyHistory /> : <HistorySkeleton />}
    </CardModal>
  );
}
